module.exports = __webpack_public_path__ + "static/img/SAPN.d7e84b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SAPN.jpg
// module id = R+DO
// module chunks = 0